module.exports = __webpack_public_path__ + "static/media/_MIC2568.thumbnail.ca36d767.png";